import { render, staticRenderFns } from "./PreviewMentions.vue?vue&type=template&id=49e9f31e&scoped=true"
import script from "./PreviewMentions.vue?vue&type=script&lang=js"
export * from "./PreviewMentions.vue?vue&type=script&lang=js"
import style0 from "./PreviewMentions.vue?vue&type=style&index=0&id=49e9f31e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9f31e",
  null
  
)

export default component.exports